// @flow

export { default as AddUser } from './icons/add_user.svg';
export { default as Alarm } from './icons/alarm.svg';
export { default as Application } from './icons/application.svg';
export { default as Archive } from './icons/archive.svg';
export { default as Arrow } from './icons/arrow.svg';
export { default as At } from './icons/at.svg';
export { default as Bitbucket } from './icons/bitbucket.svg';
export { default as BurgerMenu } from './icons/burgerMenu.svg';
export { default as Cards } from './icons/cards.svg';
export { default as CheckMark } from './icons/checkMark.svg';
export { default as Cluster } from './icons/cluster.svg';
export { default as Code } from './icons/code.svg';
export { default as Comment } from './icons/comment.svg';
export { default as CopyClipboard } from './icons/copyClipboard.svg';
export { default as Cpu } from './icons/cpu.svg';
export { default as Delete } from './icons/delete.svg';
export { default as DevCenter } from './icons/devCenter.svg';
export { default as Docs } from './icons/docs.svg';
export { default as Download } from './icons/download.svg';
export { default as Edit } from './icons/edit.svg';
export { default as Environment } from './icons/environment.svg';
export { default as Exclamationmark } from './icons/exclamationmark.svg';
export {
  default as ExclamationMarkSolid,
} from './icons/exclamationMarkSolid.svg';
export { default as Explore } from './icons/explore.svg';
export { default as Fail } from './icons/fail.svg';
export { default as Filtering } from './icons/filtering.svg';
export { default as Flag } from './icons/flag.svg';
export { default as Github } from './icons/github.svg';
export { default as Group } from './icons/group.svg';
export { default as IdeasBox } from './icons/ideasBox.svg';
export { default as Learn } from './icons/learn.svg';
export { default as Links } from './icons/links.svg';
export { default as List } from './icons/list.svg';
export { default as Location } from './icons/location.svg';
export { default as Logout } from './icons/logout.svg';
export { default as MachineType } from './icons/machineType.svg';
export { default as Marketplace } from './icons/marketplace.svg';
export { default as Master } from './icons/master.svg';
export { default as Memory } from './icons/memory.svg';
export { default as Nodes } from './icons/nodes.svg';
export { default as Options } from './icons/options.svg';
export { default as Organization } from './icons/organization.svg';
export { default as Padlock } from './icons/padlock.svg';
export { default as Pipeline } from './icons/pipeline.svg';
export { default as Plus } from './icons/plus.svg';
export { default as Refresh } from './icons/refresh.svg';
export { default as Releases } from './icons/releases.svg';
export { default as Runs } from './icons/runs.svg';
export { default as Search } from './icons/search.svg';
export { default as Settings } from './icons/settings.svg';
export { default as Signin } from './icons/signin.svg';
export { default as Size } from './icons/size.svg';
export { default as StackOverflow } from './icons/stackOverflow.svg';
export { default as Slack } from './icons/slack.svg';
export { default as Steps } from './icons/steps.svg';
export { default as Tag } from './icons/tag.svg';
export { default as Terminal } from './icons/terminal.svg';
export { default as Time } from './icons/time.svg';
export { default as Undo } from './icons/undo.svg';
export { default as Upload } from './icons/upload.svg';
export { default as User } from './icons/user.svg';
export { default as Workflow } from './icons/workflow.svg';
export { default as XMark } from './icons/xMark.svg';



// WEBPACK FOOTER //
// ../icon/src/index.js